import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import DashboardNavbar from './components/DashboardNavbar';
import ClientLogin from './pages/ClientLogin';
import RequestNDA from './pages/RequestNDA';
import ScheduleCall from './pages/ScheduleCall';
import AuthenticatedPage from './pages/AuthenticatedPage';
import Documents from './pages/Documents';
import Requests from './pages/Requests';
import Profile from './pages/Profile';
import ResetPassword from './components/ResetPassword';
import NotRegistered from './pages/NotRegistered';
import OnboardingPage from './pages/OnboardingPage';
import { supabase } from './supabase';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  const [user, setUser] = useState(null);
  const [authUserId, setAuthUserId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        setUser(session.user);
        setAuthUserId(session.user.id);
      }
    };

    checkAuth();

    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT") {
        setUser(null);
        setAuthUserId(null);
        navigate('/');
      } else if (event === "SIGNED_IN" && session) {
        setUser(session.user);
        setAuthUserId(session.user.id);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      const logoutAndReset = async () => {
        await supabase.auth.signOut();
        setUser(null);
        setAuthUserId(null);
        navigate('/');
      };
      logoutAndReset();
    }
  }, [location.pathname]);

  const navbarRoutes = ["/", "/share-details", "/request-nda", "/discovery", "/schedule-call"];
  const showNavbar = navbarRoutes.includes(location.pathname);
  const hideAllNavbars = location.pathname === "/reset" || location.pathname === "/not-registered" || location.pathname === "/onboarding";

  return (
    <WorkspaceProvider authUserId={authUserId}>
      <LanguageProvider>
        <div className="App">
          {!hideAllNavbars && (user ? <DashboardNavbar /> : showNavbar && <Navbar />)}
          <div className="content">
            <Routes>
              <Route path="/" element={<ClientLogin setUser={setUser} />} />
              <Route path="/reset" element={<ResetPassword />} />
              <Route path="/request-nda" element={<RequestNDA />} />
              <Route path="/schedule-call" element={<ScheduleCall />} />
              <Route path="/dashboard" element={<AuthenticatedPage />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/requests" element={<Requests />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/not-registered" element={<NotRegistered />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
            </Routes>
          </div>
        </div>
      </LanguageProvider>
    </WorkspaceProvider>
  );
}

export default App;